import { isEqual } from "lodash";
import { SCACHE_GROUPS } from "../core/constants/cacheKeys";
import EGroup from "../core/contracts/EGroup";
import { SessionCache } from "../helpers/cache";
import { isArrayValid } from "../helpers/utility";
import BaseService from "./BaseService";

type GroupServicePostParams = {
  newGroup: EGroup;
  previousGroup: EGroup;
};

export default class GroupService {
  async fetchAll() {
    try {
      const response = new BaseService(true).get("Group/ListarTodos");

      if (isArrayValid(response)) new SessionCache().set(SCACHE_GROUPS, response);

      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
    }
  }

  async fetch(groupId: string) {
    try {
      if (!groupId) {
        return Promise.reject("Nenhum Id de Grupo fornecido!");
      }
      // Try retrieving from cache
      const cache = new SessionCache();
      const cachedGroups = cache.get<EGroup[]>(SCACHE_GROUPS);

      let ret: EGroup | undefined;

      if (isArrayValid(cachedGroups)) {
        ret = cachedGroups?.find((x) => x.id === groupId);

        if (ret) {
          return Promise.resolve(ret);
        }
      }

      ret = await new BaseService().get(`Group?id=${groupId}`);
      return ret;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("🚀 ~ file: GroupService.ts ~ line 9 ~ GroupService ~ fetch ~ error", error);
      return Promise.reject(error);
    }
  }

  async post(params: GroupServicePostParams) {
    try {
      const { newGroup, previousGroup } = params;

      const postObj = params.newGroup;

      if (!newGroup?.id) {
        delete newGroup?.id;
      }

      const savedGroup: EGroup = await new BaseService(true).post(
        "Group/CriarOuAtualizar",
        postObj
      );

      if (isEqual(newGroup?.usuarios, previousGroup?.usuarios)) {
        return Promise.resolve(true);
      }

      // Front faz as associações e dessasociações de usuários com grupo
      const previousGroupUsersIds = previousGroup?.usuarios?.map((x) => x.codigo);
      const newGroupUsersIds = newGroup?.usuarios?.map((x) => x.codigo);

      const removeUsersFromGroup: string[] = [];
      const addUsersFromGroup: string[] = [];

      if (savedGroup?.id) {
        // add users
        newGroupUsersIds.forEach((id) => {
          if (!previousGroupUsersIds?.includes(id)) {
            return addUsersFromGroup.push(id);
          }
        });

        // remove users
        previousGroupUsersIds?.forEach((oldId) => {
          if (!newGroupUsersIds.includes(oldId)) {
            return removeUsersFromGroup.push(oldId);
          }
        });
      }

      const associateDisassociateUsersObj = [
        ...(removeUsersFromGroup?.map((x) => {
          return {
            filter: x,
            group_id: null,
          };
        }) ?? []),
        ...(addUsersFromGroup?.map((x) => {
          return {
            filter: x,
            group_id: savedGroup.id,
          };
        }) ?? []),
      ];

      if (isArrayValid(associateDisassociateUsersObj)) {
        return new BaseService(true).post(
          "User/AssociarUsuariosAGrupos",
          associateDisassociateUsersObj
        );
      }

      // TODO - Avaliar se isto faz sentido!
      return Promise.resolve(true);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("🚀 ~ file: GroupService.ts ~ line 48 ~ GroupService ~ post ~ error", error);
      return Promise.reject(error);
    }
  }

  async delete(groupId: string) {
    try {
      if (!groupId) {
        return Promise.reject("Nenhum Id de Grupo fornecido!");
      }
      return await new BaseService(true).post(`Group/Deletar?id=${groupId}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("🚀 ~ file: GroupService.ts ~ line 9 ~ GroupService ~ fetch ~ error", error);
      return Promise.reject(error);
    }
  }
}
